module.exports = __webpack_public_path__ + "img/Goal_17.c9bd77f5.png";